export const CONTACT_NORMALIZATION_DEFAULT_WORKFLOW_INSTANCE_ID = "wf-contact-normalization-default";

export const CONTACT_NORMALIZATION_NODE_TYPES = Object.freeze({
  PHONE: "phone",
  EMAIL: "email",
});

export const CONTACT_NORMALIZATION_NODE_KEY_TO_TYPE = Object.freeze({
  "phone-normalization": CONTACT_NORMALIZATION_NODE_TYPES.PHONE,
  "email-normalization": CONTACT_NORMALIZATION_NODE_TYPES.EMAIL,
});

export const createContactNormalizationTemplate = (t) => ({
  key: "contact-normalization",
  name: t("ncrm.workflows.templates.contactNormalization.name"),
  description: t("ncrm.workflows.templates.contactNormalization.description"),
});

export const createContactNormalizationNodeDefinitions = (t) => [
  {
    key: "phone-normalization",
    label: t("ncrm.workflows.nodes.phoneNormalization.label"),
    description: t("ncrm.workflows.nodes.phoneNormalization.description"),
    icon: "mdi-phone-check-outline",
    color: "primary",
    statusKey: "ready",
  },
  {
    key: "email-normalization",
    label: t("ncrm.workflows.nodes.emailNormalization.label"),
    description: t("ncrm.workflows.nodes.emailNormalization.description"),
    icon: "mdi-email-check-outline",
    color: "info",
    statusKey: "ready",
  },
];

export const createDefaultPhoneNormalizationSettings = () => ({
  status: "active",
  description: "",
  defaultCountry: "MD",
});

export const createDefaultEmailNormalizationSettings = () => ({
  status: "active",
  description: "",
});

export const buildContactNormalizationSummary = () => ({
  endpointId: null,
  endpoint: null,
  trigger: "ncrm_company",
  sourceSystem: "CRM",
  sources: ["ncrm_company", "phone/email"],
});
